import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles(theme => ({
    dashletBox: {
        border: '#cccc80 solid thin',
        borderRadius:'8px !important',
        // borderTop: theme.palette.primary.main + ' solid 3px',
        
    },
    dashletContentRoot: {
        padding: '10px',
        height: '92%',
        overflow: 'auto'
    },
    dashletList: {
        marginBottom: '10px'
    },
    noDashletsRoot: {
        marginTop: '100px',
        padding: '50px 30px 25px 30px'
    },
    dashletHeader: {
        
        backgroundColor: '#494DF4',//theme.palette.primary.main,
        color: '#FFFFFF',
        fontSize: "1.2rem",
        // paddingLeft: "3.4%",
        fontWeight: "bold",
        padding: "5px 14px 5px 5px",
        // borderRadius: '8px 8px 0px 0px',
        textAlign:'center'
        // borderBottom: theme.palette.text.primary + ' groove 0.1px'
    },

    //   media: {
    //     height: 140,
    //   },
    table: {
        minWidth: 500,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100px',
        maxHeight: '100px',
    },
    imgBox: {

        padding: '50px'
    },
    btnAlign: {
        textAlign: 'center'
    },
    chartBox: {
        padding: '10px',
        marginBottom: '10px',
        boxShadow: 'none'

    },
    dashletActions: {
        padding: 0,
    },
    selectFontDash: {
        fontSize: "0.875rem",
    },
    IconCss:{
        // width: "48px",
        height: "40px"
    },

}))


export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
        ...selectedTheme,
        overrides: {
            MuiCard:{
                root:{
                marginBottom:'10px'
                }
            },
            MuiPaper: {
             
                rounded:{
                    borderRadius:'8px !important'
                }
            },
            MuiCardHeader:{
                avatar:{
                    marginRight: "0px !important"
                }
            },
          
        },
    })
}
